import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=a0cee612&scoped=true"
import script from "./AvatarUpload.vue?vue&type=script&lang=js"
export * from "./AvatarUpload.vue?vue&type=script&lang=js"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=a0cee612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cee612",
  null
  
)

export default component.exports